import {MAX_BENEFICIARIES} from 'redux/reducers/beneficiariesReducer';

export class MaxBeneficiariesExceededError extends Error {
    constructor() {
        super(`Cannot add more than ${MAX_BENEFICIARIES} beneficiaries.`);
    }
}
